/* eslint-disable no-script-url */
import { useSignal, useSignalEffect } from "@preact/signals-react";
import { useContext, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext, AuthContexType } from "../../context/AuthContext";
import { MenuContext, MenuContextType } from "../../context/MenuContext";
import { app } from "../../signals/AppSignal";

const Sidebar = () => {
  useSignal(0);

  const location = useLocation();
  const { setMenuToggle } = useContext(MenuContext) as MenuContextType;
  const { setUserToken } = useContext(AuthContext) as AuthContexType;

  const [isSTPApp, setIsSTPApp] = useState<boolean>(false);

  const activeRoute = (routeName: string) => {
    return location.pathname === routeName;
  };

  const getMainPath = (path: string) => {
    return location.pathname.split("/")[1] === path;
  };

  const handleLogout = () => {
    sessionStorage.removeItem("sess");
    setUserToken(false);
  };

  useSignalEffect(() => {
    setIsSTPApp(app.value === "stp" ? true : false);
  });

  return (
    <aside
      className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2  bg-white my-2"
      id="sidenav-main"
    >
      <div className="sidenav-header align-center">
        <i
          className="fas fa-times p-3 cursor-pointer text-dark opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
          aria-hidden="true"
          id="iconSidenav"
        ></i>
        <a
          className="navbar-brand px-4 py-3 m-0"
          href="https://getfluidapps.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://getfluidapps.com/wp-content/uploads/2025/02/fluidapps-logo-nbg.png"
            className="navbar-brand-img"
            alt="main_logo"
          ></img>
        </a>
      </div>
      <hr className="horizontal dark mt-0 mb-2" />
      <div
        className="collapse navbar-collapse  w-auto h-auto"
        id="sidenav-collapse-main"
      >
        <ul className="navbar-nav">
          <li className={`nav-item ${activeRoute("/") && "active"}`}>
            <NavLink
              className={`nav-link text-dark ${activeRoute("/") && "active"}`}
              to={"/dashboard"}
              onClick={() => setMenuToggle(false)}
            >
              <i className="material-symbols-rounded opacity-5">
                space_dashboard
              </i>
              <span className="nav-link-text ms-1 ps-1">Dashboards</span>
            </NavLink>
          </li>

          <li className="nav-item mt-3">
            <h6 className="ps-3  ms-2 text-uppercase text-xs font-weight-bolder text-dark">
              PAGES
            </h6>
          </li>

          <li className="nav-item">
            <a
              data-bs-toggle="collapse"
              href="#accountsMenuList"
              className={`nav-link text-dark ${getMainPath("customers") ? "active" : ""}`}
              aria-controls="accountsMenuList"
              role="button"
              aria-expanded={getMainPath("customers")}
            >
              <i className="material-symbols-rounded opacity-5">
                account_circle
              </i>
              <span className="nav-link-text ms-1 ps-1">Customer</span>
            </a>
            <div className="collapse" id="accountsMenuList">
              <ul className="nav">
                <li className="nav-item active">
                  <NavLink
                    className={`nav-link text-dark ${
                      activeRoute("/customers/accounts") ? "active" : ""
                    }`}
                    to="/customers/accounts"
                    onClick={() => setMenuToggle(false)}
                  >
                    <span className="sidenav-mini-icon"> A </span>
                    <span className="sidenav-normal  ms-1  ps-1">
                      {" "}
                      Accounts{" "}
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item active">
                  <NavLink
                    className={`nav-link text-dark ${
                      activeRoute("/customers/users") ? "active" : ""
                    }`}
                    to="/customers/users"
                    onClick={() => setMenuToggle(false)}
                  >
                    <span className="sidenav-mini-icon"> U </span>
                    <span className="sidenav-normal  ms-1  ps-1"> Users </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>

          <li className="nav-item">
            <a
              data-bs-toggle="collapse"
              href="#activitiesMenuList"
              className={`nav-link text-dark ${getMainPath("activities") ? "active" : ""}`}
              aria-controls="activitiesMenuList"
              role="button"
              aria-expanded={getMainPath("activities")}
            >
              <i className="material-symbols-rounded opacity-5">monitoring</i>
              <span className="nav-link-text ms-1 ps-1">Activities</span>
            </a>
            <div className="collapse" id="activitiesMenuList">
              <ul className="nav">
                <li className="nav-item active">
                  <NavLink
                    className={`nav-link text-dark ${
                      activeRoute("/activities/installations") ? "active" : ""
                    }`}
                    to="/activities/installations"
                    onClick={() => setMenuToggle(false)}
                  >
                    <span className="sidenav-mini-icon"> I </span>
                    <span className="sidenav-normal  ms-1  ps-1">
                      {" "}
                      Installations{" "}
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item active">
                  <NavLink
                    className={`nav-link text-dark ${
                      activeRoute("/activities/subscriptions") ? "active" : ""
                    }`}
                    to="/activities/subscriptions"
                    onClick={() => setMenuToggle(false)}
                  >
                    <span className="sidenav-mini-icon"> S </span>
                    <span className="sidenav-normal  ms-1  ps-1">
                      {" "}
                      Subscriptions{" "}
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item active">
                  <NavLink
                    className={`nav-link text-dark ${
                      activeRoute("/activities/transactions") ? "active" : ""
                    }`}
                    to="/activities/transactions"
                    onClick={() => setMenuToggle(false)}
                  >
                    <span className="sidenav-mini-icon"> T </span>
                    <span className="sidenav-normal  ms-1  ps-1">
                      {" "}
                      Transactions{" "}
                    </span>
                  </NavLink>
                </li>

                {isSTPApp && (
                  <li className="nav-item active">
                    <NavLink
                      className={`nav-link text-dark ${
                        activeRoute("/activities/transactions-errors")
                          ? "active"
                          : ""
                      }`}
                      to="/activities/transactions-errors"
                      onClick={() => setMenuToggle(false)}
                    >
                      <span className="sidenav-mini-icon"> E </span>
                      <span className="sidenav-normal  ms-1  ps-1">
                        {" "}
                        Errors{" "}
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>

          {/* <li className="nav-item">
            <hr className="horizontal dark" />
            <h6 className="ps-3  ms-2 text-uppercase text-xs font-weight-bolder text-dark">
              REPORTS
            </h6>
          </li>
          <li className="nav-item active">
            <NavLink
              className={`nav-link text-dark ${
                activeRoute("/reports/inactive") ? "active" : ""
              }`}
              to="/reports/inactive"
              onClick={()=> setMenuToggle(false)}
            >
              <span className="sidenav-mini-icon"> I </span>
              <span className="sidenav-normal ms-1 ps-1"> Inactive </span>
            </NavLink>
          </li>
          <li className="nav-item active">
            <NavLink
              className={`nav-link text-dark ${
                activeRoute("/reports/unauthorize") ? "active" : ""
              }`}
              to="/reports/unauthorize"
              onClick={()=> setMenuToggle(false)}
            >
              <span className="sidenav-mini-icon"> U </span>
              <span className="sidenav-normal ms-1 ps-1"> Unauthorized </span>
            </NavLink>
          </li>

          <li className="nav-item">
            <hr className="horizontal dark" />
          </li> */}

          <li className={`nav-item ${activeRoute("/") && "active"}`}>
            <a className="nav-link text-dark" href="#" onClick={handleLogout}>
              <i className="material-symbols-rounded opacity-5">logout</i>
              <span className="nav-link-text ms-1 ps-1">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
